var common = require("./common.js");

module.exports = async function(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;

  var dashboard = (context || {}).dashboard || {};
  var passkeyList = document.getElementById("passkey-list");
  var passkeyResult = document.getElementById("passkey-create-result");
  var createBtn = document.getElementById("create-passkey");
  var nameInput = document.getElementById("new-passkey-name");
  var profileNameInput = document.getElementById("profile-name");
  var saveProfileButton = document.getElementById("save-profile-name");
  var profileResult = document.getElementById("profile-result");
  var usersResult = document.getElementById("users-result");
  var usersList = document.getElementById("users-list");
  var rolesResult = document.getElementById("roles-result");
  var rolesList = document.getElementById("roles-list");
  var addUserNameInput = document.getElementById("add-user-name");
  var addUserEmailInput = document.getElementById("add-user-email");
  var addUserRolesInput = document.getElementById("add-user-roles");
  var addUserButton = document.getElementById("add-user-button");
  var roleNamespaceInput = document.getElementById("role-namespace");
  var roleTitleInput = document.getElementById("role-title");
  var roleDescriptionInput = document.getElementById("role-description");
  var roleCanAssignInput = document.getElementById("role-canassign");
  var rolePasskeyInput = document.getElementById("role-passkey");
  var roleSaveButton = document.getElementById("role-save-button");

  async function reloadPasskeys() {
    if (!(passkeyList)) return;
    var listResponse = await fetch("/auth/passkey/list");
    var listJson = await listResponse.json();
    if (!(listResponse.ok) || !(listJson.success)) {
      passkeyList.innerHTML = "<div class='alert alert-danger mb-0'>Unable to load passkeys.</div>";
      return;
    }

    var rows = listJson.data || [];
    if (!(rows instanceof Array) || rows.length === 0) {
      passkeyList.innerHTML = "<p class='m-0'>No passkeys yet.</p>";
      return;
    }

    var html = "<ul class='list-group'>";
    for (var i = 0; i < rows.length; i++) {
      var createdOnHtml = await common.renderTimestampHtml(rows[i].createdOn || "");
      html += "<li class='list-group-item d-flex justify-content-between align-items-center'>";
      html += "<span><strong>" + rows[i].name + "</strong><br><small>" + createdOnHtml + "</small></span>";
      html += "<button class='btn btn-sm btn-outline-danger' data-passkey-id='" + rows[i].id + "'>Disable</button>";
      html += "</li>";
    }
    html += "</ul>";
    passkeyList.innerHTML = html;

    var deleteButtons = passkeyList.querySelectorAll("button[data-passkey-id]");
    for (var j = 0; j < deleteButtons.length; j++) {
      deleteButtons[j].addEventListener("click", async function() {
        var id = this.getAttribute("data-passkey-id");
        await fetch("/auth/passkey/delete", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: id })
        });
        await reloadPasskeys();
      });
    }
  }

  async function reloadRoleDefinitions() {
    if (!(rolesList) && !(addUserRolesInput)) return [];
    var response = await fetch("/auth/role-definition/list");
    var json = await response.json();
    if (!(response.ok) || !(json.success)) {
      if (rolesList) rolesList.innerHTML = "<div class='alert alert-danger mb-0'>Unable to load role definitions.</div>";
      return [];
    }

    var rows = json.data || [];
    var html = "<table class='table table-sm'><thead><tr><th>Namespace</th><th>Title</th><th>Passkey</th><th>Actions</th></tr></thead><tbody>";
    if (addUserRolesInput) addUserRolesInput.innerHTML = "";

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var namespace = (row.namespace || "");
      var isSystemRole = (namespace.indexOf(".") < 0) || (namespace.indexOf("admin.app") === 0) || (namespace.indexOf("superadmin.universe") === 0);
      var option = document.createElement("option");
      option.value = namespace;
      option.textContent = namespace;
      if (addUserRolesInput) addUserRolesInput.appendChild(option);

      html += "<tr>";
      html += "<td>" + namespace + "</td>";
      html += "<td>" + (row.title || "") + "</td>";
      html += "<td>" + (row.requiresPasskey ? "Yes" : "No") + "</td>";
      html += "<td>";
      if (!(isSystemRole)) {
        html += "<button class='btn btn-sm btn-outline-danger role-delete' data-role-namespace='" + namespace + "'>Delete</button>";
      } else {
        html += "<span class='text-muted small'>System</span>";
      }
      html += "</td>";
      html += "</tr>";
    }

    html += "</tbody></table>";
    if (rolesList) rolesList.innerHTML = html;

    if (!(rolesList)) return rows;

    var roleDeleteButtons = rolesList.querySelectorAll("button.role-delete");
    for (var j = 0; j < roleDeleteButtons.length; j++) {
      roleDeleteButtons[j].addEventListener("click", async function() {
        var ns = this.getAttribute("data-role-namespace") || "";
        var repo = await fetch("/auth/role-definition/delete", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ namespace: ns })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(rolesResult, "text-danger", "Unable to delete role.");
          return;
        }
        common.setSmallResult(rolesResult, "text-success", "Role deleted.");
        await reloadRoleDefinitions();
        await reloadUsers();
      });
    }

    return rows;
  }

  async function reloadUsers() {
    if (!(usersList)) return;
    var response = await fetch("/auth/users/list");
    var json = {};
    try {
      json = await response.json();
    } catch (error) {
      json = {};
    }
    if (!(response.ok) || !(json.success)) {
      var errorObject = (((json || {}).errors || [])[0]) || {};
      var errorDescription = (errorObject.description || errorObject.message || errorObject.title || "").toString().trim();
      if (!(errorDescription)) {
        errorDescription = "Unable to load users.";
      }
      usersList.innerHTML = "<div class='alert alert-danger mb-0'>" + errorDescription + "</div>";
      return;
    }

    var rows = json.data || [];
    if (!(rows instanceof Array) || rows.length === 0) {
      usersList.innerHTML = "<p class='m-0'>No users found.</p>";
      return;
    }

    var html = "<table class='table table-sm'><thead><tr><th>Name</th><th>Email</th><th>Roles</th><th>Status</th><th>Actions</th></tr></thead><tbody>";
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      var roleText = ((row.roles || []).join(", "));
      var lockedSuperadmin = ((row.roles || []).indexOf("superadmin.universe") >= 0);
      html += "<tr>";
      html += "<td>" + ((row.name || "").toString() || "<span class='text-muted'>-</span>") + "</td>";
      html += "<td>" + (row.email || "") + "</td>";
      html += "<td><input class='form-control form-control-sm user-roles' data-user-email='" + (row.email || "") + "' value='" + roleText + "'></td>";
      html += "<td>" + (row.exists ? "Registered" : "Invited") + "</td>";
      html += "<td class='d-flex gap-1'>";
      html += "<button class='btn btn-sm btn-outline-primary user-save' data-user-email='" + (row.email || "") + "'>Save</button>";
      if (!(lockedSuperadmin)) {
        html += "<button class='btn btn-sm btn-outline-danger user-remove' data-user-email='" + (row.email || "") + "'>Remove</button>";
      } else {
        html += "<span class='text-muted small'>Protected</span>";
      }
      html += "</td>";
      html += "</tr>";
    }
    html += "</tbody></table>";
    usersList.innerHTML = html;

    var saveButtons = usersList.querySelectorAll("button.user-save");
    for (var s = 0; s < saveButtons.length; s++) {
      saveButtons[s].addEventListener("click", async function() {
        var email = this.getAttribute("data-user-email") || "";
        var rowElement = this.closest("tr");
        var rolesInput = rowElement ? rowElement.querySelector("input.user-roles") : null;
        var roleList = ((rolesInput && rolesInput.value) || "").split(",").map(function(item) {
          return item.trim();
        }).filter(Boolean);

        var repo = await fetch("/auth/access/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            roles: roleList
          })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(usersResult, "text-danger", "Failed to update user roles.");
          return;
        }
        common.setSmallResult(usersResult, "text-success", "User roles updated.");
        await reloadUsers();
      });
    }

    var removeButtons = usersList.querySelectorAll("button.user-remove");
    for (var r = 0; r < removeButtons.length; r++) {
      removeButtons[r].addEventListener("click", async function() {
        var email = this.getAttribute("data-user-email") || "";
        var repo = await fetch("/auth/access/remove", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email })
        });
        var body = await repo.json();
        if (!(repo.ok) || !(body.success)) {
          common.setSmallResult(usersResult, "text-danger", "Unable to remove access.");
          return;
        }
        common.setSmallResult(usersResult, "text-success", "Access removed.");
        await reloadUsers();
      });
    }
  }

  if (createBtn && passkeyResult && nameInput) {
    createBtn.addEventListener("click", async function() {
      passkeyResult.innerHTML = "";
      if (!(window.PublicKeyCredential && navigator.credentials && typeof navigator.credentials.create === "function")) {
        passkeyResult.innerHTML = "<div class='text-danger'>Passkeys are not supported in this browser.</div>";
        return;
      }

      var name = (nameInput.value || "").trim();
      var optionsRepo = await fetch("/auth/passkey/register/options", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name })
      });
      var optionsJson = await optionsRepo.json();
      if (!(optionsRepo.ok) || !(optionsJson.success)) {
        passkeyResult.innerHTML = "<div class='text-danger'>Failed to create passkey.</div>";
        return;
      }

      var options = (optionsJson || {}).data || {};
      var publicKey = {
        challenge: common.fromBase64Url(options.challenge || ""),
        rp: options.rp || undefined,
        user: {
          id: common.fromBase64Url((((options || {}).user || {}).id || "")),
          name: (((options || {}).user || {}).name || ""),
          displayName: (((options || {}).user || {}).displayName || "")
        },
        pubKeyCredParams: options.pubKeyCredParams || [{ type: "public-key", alg: -7 }],
        timeout: options.timeout || 60000,
        attestation: options.attestation || "none",
        authenticatorSelection: options.authenticatorSelection || { userVerification: "preferred" }
      };

      var credential = null;
      try {
        credential = await navigator.credentials.create({ publicKey: publicKey });
      } catch (error) {
        passkeyResult.innerHTML = "<div class='text-danger'>Passkey registration was canceled or failed.</div>";
        return;
      }

      if (!(credential)) {
        passkeyResult.innerHTML = "<div class='text-danger'>Passkey registration failed.</div>";
        return;
      }

      var verifyRepo = await fetch("/auth/passkey/register/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name,
          challenge: options.challenge,
          id: credential.id,
          rawId: common.toBase64Url(new Uint8Array(credential.rawId)),
          type: credential.type,
          response: {
            clientDataJSON: common.toBase64Url(new Uint8Array(credential.response.clientDataJSON)),
            attestationObject: common.toBase64Url(new Uint8Array(credential.response.attestationObject))
          }
        })
      });
      var verifyJson = await verifyRepo.json();
      if (!(verifyRepo.ok) || !(verifyJson.success)) {
        passkeyResult.innerHTML = "<div class='text-danger'>Passkey registration failed during verification.</div>";
        return;
      }

      passkeyResult.innerHTML = "<div class='alert alert-success mb-0'>Passkey installed for this account.</div>";
      nameInput.value = "";
      await reloadPasskeys();
    });
  }

  if (profileNameInput) {
    profileNameInput.value = ((((dashboard.user || {}).name) || "") + "");
  }

  if (saveProfileButton && profileNameInput) {
    saveProfileButton.addEventListener("click", async function() {
      var repo = await fetch("/auth/profile/update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: (profileNameInput.value || "").trim() })
      });
      var body = {};
      try {
        body = await repo.json();
      } catch (error) {
        body = {};
      }
      if (!(repo.ok) || !(body.success)) {
        var errorObject = (((body || {}).errors || [])[0]) || {};
        var errorDescription = (errorObject.description || errorObject.message || errorObject.title || "").toString().trim();
        if (!(errorDescription)) {
          errorDescription = "Unable to save profile name.";
        }
        common.setSmallResult(profileResult, "text-danger", errorDescription);
        return;
      }
      common.setSmallResult(profileResult, "text-success", "Profile updated.");
      window.location.reload();
    });
  }

  if (addUserButton && addUserEmailInput && addUserNameInput && addUserRolesInput) {
    addUserButton.addEventListener("click", async function() {
      var payload = {
        name: (addUserNameInput.value || "").trim(),
        email: (addUserEmailInput.value || "").trim(),
        roles: common.getSelectedValues(addUserRolesInput)
      };
      var repo = await fetch("/auth/access/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      var body = await repo.json();
      if (!(repo.ok) || !(body.success)) {
        common.setSmallResult(usersResult, "text-danger", "Unable to add/update user.");
        return;
      }
      common.setSmallResult(usersResult, "text-success", "User access saved.");
      addUserEmailInput.value = "";
      addUserNameInput.value = "";
      await reloadUsers();
    });
  }

  if (roleSaveButton && roleNamespaceInput && roleTitleInput && roleDescriptionInput && roleCanAssignInput) {
    roleSaveButton.addEventListener("click", async function() {
      var payload = {
        definition: {
          namespace: (roleNamespaceInput.value || "").trim().toLowerCase(),
          title: (roleTitleInput.value || "").trim(),
          description: (roleDescriptionInput.value || "").trim(),
          canAssign: (roleCanAssignInput.value || "").split(",").map(function(item) { return item.trim().toLowerCase(); }).filter(Boolean),
          requiresPasskey: !!(rolePasskeyInput && rolePasskeyInput.checked)
        }
      };
      var repo = await fetch("/auth/role-definition/upsert", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      var body = await repo.json();
      if (!(repo.ok) || !(body.success)) {
        common.setSmallResult(rolesResult, "text-danger", "Unable to save role.");
        return;
      }
      common.setSmallResult(rolesResult, "text-success", "Role saved.");
      await reloadRoleDefinitions();
      await reloadUsers();
    });
  }

  if (passkeyList) await reloadPasskeys();
  if (rolesList || addUserRolesInput) await reloadRoleDefinitions();
  if (usersList) await reloadUsers();
};
